import { readBuildTimeVar } from './build-time-var';

declare const TOEGANG_CLIENT_SECRETS: string | undefined;

export const toegangClientSecret = (client: string): string => {
  const secretsJson = readBuildTimeVar(() => TOEGANG_CLIENT_SECRETS, '{}');
  const secrets: Record<string, string> = JSON.parse(secretsJson);
  const secret = secrets[client.toLowerCase()];

  if (!secret) {
    console.warn(
      `TOEGANG_CLIENT_SECRET_${client.toUpperCase()} is not defined. Please set it in your environment variables.`,
    );
    return '';
  }

  return secret;
};
